import {
  WorkflowInstanceRefDocument,
  WorkflowInstanceRefFragment,
  WorkflowInstanceRefFragmentDoc,
  WorkflowInstanceRefQuery,
  WorkflowInstanceRefQueryVariables,
  withStandardRefHook,
} from '@spotify/confidence-graphql';

export const useWorkflowInstanceRef = withStandardRefHook<
  WorkflowInstanceRefQuery,
  WorkflowInstanceRefFragment,
  'workflowInstance',
  WorkflowInstanceRefQueryVariables
>(
  WorkflowInstanceRefDocument,
  'workflowInstance',
  WorkflowInstanceRefFragmentDoc,
  'WorkflowInstanceRef',
  'WorkflowV1WorkflowInstance',
);
